var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.3125 34.375V38.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.896 45.8333H35.7293V43.75C35.7293 41.4583 33.8543 39.5833 31.5627 39.5833H19.0627C16.771 39.5833 14.896 41.4583 14.896 43.75V45.8333V45.8333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.8125 45.8333H37.8125",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.9998 33.3334C16.9373 33.3334 10.4165 26.8125 10.4165 18.75V12.5C10.4165 7.89585 14.1457 4.16669 18.7498 4.16669H31.2498C35.854 4.16669 39.5832 7.89585 39.5832 12.5V18.75C39.5832 26.8125 33.0623 33.3334 24.9998 33.3334Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.3958 24.2708C9.83333 23.7708 8.45833 22.8542 7.375 21.7708C5.5 19.6875 4.25 17.1875 4.25 14.2708C4.25 11.3542 6.54167 9.0625 9.45833 9.0625H10.8125C10.3958 10.0208 10.1875 11.0833 10.1875 12.1875V18.4375C10.1875 20.5208 10.625 22.4792 11.3958 24.2708Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M38.604 24.2708C40.1665 23.7708 41.5415 22.8542 42.6248 21.7708C44.4998 19.6875 45.7498 17.1875 45.7498 14.2708C45.7498 11.3542 43.4582 9.0625 40.5415 9.0625H39.1873C39.604 10.0208 39.8123 11.0833 39.8123 12.1875V18.4375C39.8123 20.5208 39.3748 22.4792 38.604 24.2708Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupIcon);
export default __webpack_public_path__ + "static/media/cup-icon.d80c7a63cf4fd3c66f4c2ef6e83e3454.svg";
export { ForwardRef as ReactComponent };